import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import dashboardLogo from "../../assets/img/lubeco_smart_white-removebg.png";
import routes from "routes";
import Logout from "components/logout/Logout";

const logo = {
  imgSrc: dashboardLogo,
  imgAlt: "Company Logo",
};

export default function MobileSidebar1() {
  const currentPath = useLocation();
  console.log(currentPath);
  const [open, setOpen] = React.useState(false);
  const [isSmallScreen, setIsSmallScreen] = React.useState(
    window.innerWidth < 820
  );
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // Update isSmallScreen state when the window is resized
  React.useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 820);
    };
    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Function to create route links
  const createLinks = (routes) => {
    return routes.map((prop, key) => (
      <ListItem key={key} disablePadding>
        <ListItemButton
          component={NavLinkRRD}
          to={prop.layout + prop.path}
          style={({ isActive }) => ({
            backgroundColor: isActive ? "#004d64" : "inherit",
            color: isActive ? "#FFD700" : "white",
            fontWeight: isActive ? "bold" : "normal",
          })}
        >
          <ListItemIcon>
            <img
              src={prop.icon}
              alt={`${prop.name} icon`}
              className="dashicon mr-2"
            />
          </ListItemIcon>
          <ListItemText primary={prop.name} />
        </ListItemButton>
      </ListItem>
    ));
  };

  const DrawerList = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "rgb(14, 61, 13)",
        height: "100%",
        color: "white",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List>{createLinks(routes)}</List>
    </Box>
  );

  return (
    <>
      {isSmallScreen && currentPath.pathname !== "/admin/index" ? (
        <div style={{ backgroundColor: "rgb(14, 61, 13)" }}>
          <IconButton onClick={toggleDrawer(true)}>
            <MenuIcon style={{ color: "white" }} />
          </IconButton>
          <Drawer
            open={open}
            onClose={toggleDrawer(false)}
            PaperProps={{
              sx: {
                backgroundColor: "rgb(14, 61, 13)",
              },
            }}
          >
            {DrawerList}
            <div style={{ marginLeft: "40px" }}>
              <Logout />
            </div>
          </Drawer>
        </div>
      ) : (
        isSmallScreen && (
          <div className="mobileSidebar">
            <IconButton onClick={toggleDrawer(true)} >
              <MenuIcon style={{ marginRight: "10px", color: "white" }} />
            </IconButton>
            <Drawer
              open={open}
              onClose={toggleDrawer(false)}
              PaperProps={{
                sx: {
                  backgroundColor: "rgb(14, 61, 13)",
                },
              }}
            >
              {DrawerList}
              <div style={{ marginLeft: "40px" }}>
                <Logout />
              </div>
            </Drawer>
          </div>
        )
      )}

    </>
  );
}
